<template>
    <div>
        <v-container fluid style="width:100%;">
        <!-- Merged results -->
        <v-row align="center" justify="center" id="result-download">
            <v-col cols="12" md="12" lg="11" xl="11" justify="center" align="center" style="">
                <v-divider></v-divider>
                <div style="margin-left:20px;text-align:left;">
                </div>
            </v-col>
        </v-row>
        <v-row align="center" justify="center">
            <v-col>

              <swiper :navigation="true" :modules="modules" class="mySwiper">
                <swiper-slide>
                         <!-- Drug class sunburst plot -->
                         <v-container eager  style="margin:0;padding:0;">
                         <v-row align="center" justify="center" eager>
                         <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;" eager>
                            <div eager>
                                <v-card eager style="text-align:center;margin:0;padding:0;width:450px;" class="elevation-0">
                                    <div eager class="" @click="dialog_sunburst_biomarker_1 = true"
                                        style="margin:auto;width:450px;height:480px;text-align:center;"
                                    >
                                        <div class="plot-title">
                                            Drug classes > Drugs > Evidence level > Citation ID
                                        </div>

                                        <div id="treatments-all-thumb-1" v-html="this.$store.getters.getProcessState('load-sunburst-biomarker-3-thumb')" style="" eager></div>
                                        <div eager id="chart-sunburst-biomarker-1-thumb" class="chart" style="width:100%;height:350px;" ></div>

                                        <v-btn @click="dialog_sunburst_1 = true" eager>
                                            Show
                                            <span style="width:10px;" eager></span>
                                            <v-icon icon="mdi-arrow-expand" eager />
                                        </v-btn>
                                    </div>
                                </v-card>

                                <v-dialog v-model="dialog_sunburst_biomarker_1" eager>
                                    <v-card style="width:1200px;margin:auto;" eager>
                                        <v-btn @click="dialog_sunburst_biomarker_1 = false" eager>Close</v-btn>
                                        <div style="height:20px;" eager></div>
                                        <div id="chart-sunburst-biomarker-1" style="width:1000px;height:1200px;" eager></div>
                                    </v-card>
                                </v-dialog>

                            </div>
                         </v-col>
                         <!-- Cancer entity sunburst plot -->
                         <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;">
                            <div class="text-center">
                                <v-card style="text-align:center;margin:0;padding:0;width:450px;" class="elevation-0">
                                    <div class="" @click="dialog_sunburst_biomarker_2 = true"
                                        style="margin:auto;width:500px;height:480px;"
                                    >
                                        <div class="plot-title">
                                            Cancer type > Evidence level > Drugs > Citation ID
                                        </div>

                                        <div id="treatments-all-thumb-2" v-html="this.$store.getters.getProcessState('load-sunburst-biomarker-4-thumb')" style=""></div>
                                        <div id="chart-sunburst-biomarker-2-thumb" class="chart" style="width:450px;height:350px;" ></div>
                                        <v-btn @click="dialog_sunburst_2 = true">
                                            Show
                                            <span style="width:10px;"></span>
                                            <v-icon icon="mdi-arrow-expand" />
                                        </v-btn>
                                    </div>
                                </v-card>

                                <v-dialog v-model="dialog_sunburst_biomarker_2" eager>
                                    <v-card style="width:1200px;margin:auto;">
                                        <v-btn @click="dialog_sunburst_biomarker_2 = false">Close</v-btn>
                                        <div style="height:20px;"></div>
                                        <div id="chart-sunburst-biomarker-2" style="width:1000px;height:1200px;"></div>
                                    </v-card>
                                </v-dialog>

                            </div>
                         </v-col></v-row>
                         </v-container>
                </swiper-slide>
                <swiper-slide>
                    <!-- Drug class sunburst plot -->
                         <v-container eager style="margin:0;padding:0;">
                         <v-row align="center" justify="center" eager>
                         <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;" eager>
                            <div eager>


                                <v-card eager style="text-align:center;margin:0;padding:0;width:500px;" class="elevation-0">
                                    <div eager class="" @click="dialog_sunburst_biomarker_3 = true"
                                        style="margin:auto;width:500px;height:480px;text-align:center;"
                                    >
                                        <div class="plot-title">
                                            Match Type > Drug classes > Drugs > Evidence level > Citation ID
                                        </div>

                                        <div id="treatments-all-thumb-3" v-html="this.$store.getters.getProcessState('load-sunburst-biomarker-3-thumb')" style="" eager></div>
                                        <div eager id="chart-sunburst-biomarker-3-thumb" class="chart" style="width:100%;height:350px;" ></div>

                                        <v-btn @click="dialog_sunburst_3 = true" eager>
                                            Show
                                            <span style="width:10px;" eager></span>
                                            <v-icon icon="mdi-arrow-expand" eager />
                                        </v-btn>
                                    </div>
                                </v-card>

                                <v-dialog v-model="dialog_sunburst_biomarker_3" eager>
                                    <v-card style="width:1200px;margin:auto;" eager>
                                        <v-btn @click="dialog_sunburst_biomarker_3 = false" eager>Close</v-btn>
                                        <div style="height:20px;" eager></div>
                                        <div id="chart-sunburst-biomarker-3" style="width:1000px;height:1200px;" eager></div>
                                    </v-card>
                                </v-dialog>

                            </div>
                         </v-col>
                         <!-- Cancer entity sunburst plot -->
                         <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;">
                            <div class="text-center">
                                <v-card style="text-align:center;margin:0;padding:0;width:500px;" class="elevation-0">
                                    <div class="" @click="dialog_sunburst_biomarker_4 = true"
                                        style="margin:auto;width:500px;height:480px;"
                                    >
                                        <div class="plot-title">
                                            Match Type > Drugs > Evidence level > Citation ID
                                        </div>

                                        <div id="treatments-all-thumb-4" v-html="this.$store.getters.getProcessState('load-sunburst-biomarker-4-thumb')" style=""></div>
                                        <div id="chart-sunburst-biomarker-4-thumb" class="chart" style="width:500px;height:350px;" ></div>
                                        <v-btn @click="dialog_sunburst_4 = true">
                                            Show
                                            <span style="width:10px;"></span>
                                            <v-icon icon="mdi-arrow-expand" />
                                        </v-btn>
                                    </div>
                                </v-card>

                                <v-dialog v-model="dialog_sunburst_biomarker_4" eager>
                                    <v-card style="width:1200px;margin:auto;">
                                        <v-btn @click="dialog_sunburst_biomarker_4 = false">Close</v-btn>
                                        <div style="height:20px;"></div>
                                        <div id="chart-sunburst-biomarker-4" style="width:1000px;height:1200px;"></div>
                                    </v-card>
                                </v-dialog>

                            </div>
                         </v-col></v-row>
                         </v-container>
                </swiper-slide>
                <swiper-slide>
                    <!-- Response type -->
             <v-container style="margin:0;padding:0;">
             <v-row align="center" justify="center">
             <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;">
                <div>


                    <v-card style="text-align:center;margin:0;padding:0;width:500px;" class="elevation-0">
                        <div class="" @click="dialog_sunburst_biomarker_5 = true"
                            style="margin:auto;width:500px;height:480px;text-align:center;"
                        >
                            <div class="plot-title">
                                Response type > Drug class > Drugs > Evidence level > Citation ID
                            </div>

                            <div id="treatments-all-thumb-5" v-html="this.$store.getters.getProcessState('load-sunburst-biomarker-5-thumb')" style=""></div>
                            <div id="chart-sunburst-biomarker-5-thumb" class="chart" style="width:100%;height:350px;" ></div>

                            <v-btn @click="dialog_sunburst_5 = true">
                                Show
                                <span style="width:10px;"></span>
                                <v-icon icon="mdi-arrow-expand" />
                            </v-btn>
                        </div>
                    </v-card>

                    <v-dialog v-model="dialog_sunburst_biomarker_5" eager>
                        <v-card style="width:1200px;margin:auto;">
                            <v-btn @click="dialog_sunburst_biomarker_5 = false">Close</v-btn>
                            <div style="height:20px;"></div>
                            <div id="chart-sunburst-biomarker-5" style="width:1000px;height:1200px;"></div>
                        </v-card>
                    </v-dialog>

                </div>
             </v-col>
             </v-row>
             </v-container>
                </swiper-slide>
              </swiper>


                         </v-col>
          </v-row>
           <v-divider></v-divider>
           <Table_Treatments/>
        </v-container>
    </div>
</template>
<script>
import { ref, onMounted, computed, watch } from 'vue';
import axios from 'axios';
import Plotly from  '@/assets/js/plotly-latest.min.js';
// Swiper is used to "swipe" the graphs from left to right, similar to the v-carousel component
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import Table_Treatments from '@/components/tables/Table_Treatments.vue';

  

const slides = computed(() => ['1','3','5']);
const page=0

export default {
    name: 'ClinicalSignificance',
    props: {
        item: {}
    },
    components: {
      Swiper,
      SwiperSlide,
      Table_Treatments,
    },
    data: () => ({
        overlay: false,
        open: ['metakb'],
        sunburst_plot: "",
                sortStates: {
            'gene': 0,
            'variant': 0,
            'disease': 0,
            'drugs': 0,
            'evidence_level': 0,
            'response': 0,
            'citation_url': 0,
            'source': 0,
        },
        iconStatesUp: {
            'gene': 'mdi-arrow-up-thin',
            'variant': 'mdi-arrow-up-thin',
            'disease': 'mdi-arrow-up-thin',
            'drugs': 'mdi-arrow-up-thin',
            'evidence_level': 'mdi-arrow-up-thin',
            'response': 'mdi-arrow-up-thin',
            'citation_url': 'mdi-arrow-up-thin',
            'source': 'mdi-arrow-up-thin'
        },
        iconStatesDn: {
            'gene': 'mdi-arrow-down-thin',
            'variant': 'mdi-arrow-down-thin',
            'disease': 'mdi-arrow-down-thin',
            'drugs': 'mdi-arrow-down-thin',
            'evidence_level': 'mdi-arrow-down-thin',
            'response': 'mdi-arrow-down-thin',
            'citation_url': 'mdi-arrow-down-thin',
            'source': 'mdi-arrow-down-thin'
        },
        dataTreatmentsSunburst1: "",
        dialog_sunburst_biomarker_1: false,
        dialog_sunburst_biomarker_2: false,
        dialog_sunburst_biomarker_3: false,
        dialog_sunburst_biomarker_4: false,
        dialog_sunburst_biomarker_5: false,
        plot1_loaded: false,
        plot2_loaded: false,
        plot3_loaded: false,
        plot4_loaded: false,
        plot5_loaded: false,
        carousel: 2,
        sunburstplots: ["1","3","5"]
    }),
    methods: {
        loadSunburstItems() {
            //alert("ok")
            this.loadSunburstPlots()
        },
        async loadSunburstPlots() {

            // graph3
            var elementExists = document.getElementById("chart-sunburst-biomarker-3-thumb");
            alert(elementExists)
            if ((elementExists) && (plot3_loaded==false)) {
                //alert("Element exists");

                formData = new FormData();
                formData.append("plot", "treatment-sunburst-match-type-drugs");
                formData.append("variant_data", JSON.stringify(this.$store.getters.getVariants) )
                await axios.post(url, formData, {
                  headers: {
                    "Content-Type": "text/html"
                  }
                }).then((response) => {
                    var response_data = response.data
                            this.$store.dispatch("setProcessState",["load-sunburst-3-thumb","<div>" + response_data + "</div>"])
                            this.TreatmentsSunburst1 = ""
                            var graphJSON = response.data
                            this.redrawBiomarkerSunburstPlot3(graphJSON,'chart-sunburst-biomarker-3')

                            this.$store.dispatch('setProcessState', [  "load-sunburst-3-thumb","" ] )
                            plot3_loaded = true
                })
            } else {
                alert("Element does not exist");
            }


            // graph4
            elementExists = document.getElementById("chart-sunburst-biomarker-4-thumb");
            //alert(elementExists)
            if ((elementExists) && (plot4_loaded==false)) {
                formData = new FormData();
                formData.append("plot", "treatment-sunburst-match-type-drug-classes");
                formData.append("variant_data", JSON.stringify(this.$store.getters.getVariants) )
                await axios.post(url, formData, {
                  headers: {
                    "Content-Type": "text/html"
                  }
                }).then((response) => {
                    var response_data = response.data
                            this.$store.dispatch("setProcessState",["load-sunburst-4-thumb","<div>" + response_data + "</div>"])
                            this.TreatmentsSunburst1 = ""
                            var graphJSON = response.data
                            this.redrawBiomarkerSunburstPlot3(graphJSON,'chart-sunburst-biomarker-4')

                            this.$store.dispatch('setProcessState', [  "load-sunburst-4-thumb","" ] )
                            plot4_loaded = true
                })
            }




            // graph5
            elementExists = document.getElementById("chart-sunburst-biomarker-5-thumb");
            //alert(elementExists)
            if ((elementExists) &&(plot5_loaded==false)) {
                formData = new FormData();
                formData.append("plot", "treatment-sunburst-response-type");
                formData.append("variant_data", JSON.stringify(this.$store.getters.getVariants) )
                await axios.post(url, formData, {
                  headers: {
                    "Content-Type": "text/html"
                  }
                }).then((response) => {
                    var response_data = response.data
                            this.$store.dispatch("setProcessState",["load-sunburst-5-thumb","<div>" + response_data + "</div>"])
                            this.TreatmentsSunburst1 = ""
                            var graphJSON = response.data
                            this.redrawBiomarkerSunburstPlot3(graphJSON,'chart-sunburst-biomarker-5')

                            this.$store.dispatch('setProcessState', [  "load-sunburst-5-thumb","" ] )
                            plot5_loaded = true
                })
            }

        },
        redrawBiomarkerSunburstPlot(graphJSON) {
            try {
                this.dataTreatmentsSunburst1 = graphJSON
                var layout = { autosize:false,width:1000, height:600, margin: { l:0,r:0,b:0,t:0, pad:0 } }
                graphJSON["layout"]["width"] = 420
                graphJSON["layout"]["height"] = 350
                graphJSON["layout"]["paper_bgcolor"] ="#ffffff"

                Plotly.plot('chart-sunburst-biomarker-1-thumb',this.dataTreatmentsSunburst1,graphJSON);

                graphJSON["layout"]["width"] = 1200
                graphJSON["layout"]["height"] = 800
                Plotly.plot('chart-sunburst-biomarker-1',this.dataTreatmentsSunburst1,graphJSON);
            } catch(err) {
                console.log(err)
            }
        },
        redrawBiomarkerSunburstPlot2(graphJSON) {
            try {
                this.dataTreatmentsSunburst1 = graphJSON
                var layout = { width:400, height:350, margin: { l:10,r:10,b:10,t:10, pad:5 } }
                graphJSON["layout"]["width"] = 420
                graphJSON["layout"]["height"] = 350
                graphJSON["layout"]["paper_bgcolor"] ="#ffffff"

                Plotly.plot('chart-sunburst-biomarker-2-thumb',graphJSON,graphJSON);

                graphJSON["layout"]["width"] = 1200
                graphJSON["layout"]["height"] = 800
                Plotly.plot('chart-sunburst-biomarker-2',graphJSON,graphJSON);
            } catch(err) {
                console.log(err)
            }
        },
        redrawBiomarkerSunburstPlot3(graphJSON,element) {
            try {
                this.dataTreatmentsSunburst1 = graphJSON
                var layout = { width:400, height:350, margin: { l:10,r:10,b:10,t:10, pad:5 } }
                //graphJSON["layout"] = {}
                graphJSON["layout"]["width"] = 420
                graphJSON["layout"]["height"] = 350
                graphJSON["layout"]["paper_bgcolor"] ="#ffffff"

                Plotly.plot(element+'-thumb',graphJSON,graphJSON);

                graphJSON["layout"]["width"] = 1200
                graphJSON["layout"]["height"] = 800
                Plotly.plot(element,graphJSON,graphJSON);
            } catch(err) {
                console.log(err)
            }
        },
        redrawBiomarkerSunburstPlot4(graphJSON) {
            try {
                this.dataTreatmentsSunburst1 = graphJSON
                var layout = { width:400, height:350, margin: { l:10,r:10,b:10,t:10, pad:5 } }
                graphJSON["layout"]["width"] = 420
                graphJSON["layout"]["height"] = 350
                graphJSON["layout"]["paper_bgcolor"] ="#ffffff"

                Plotly.plot('chart-sunburst-biomarker-4-thumb',graphJSON,graphJSON);

                graphJSON["layout"]["width"] = 1200
                graphJSON["layout"]["height"] = 800
                Plotly.plot('chart-sunburst-biomarker-4',graphJSON,graphJSON);
            } catch(err) {
                console.log(err)
            }
        },
        sortTreatmentList(feature) {
            let data = this.$store.getters.getActiveBiomarker
            //alert(JSON.stringify(data))
            //let keys = Object.keys(data)
            for (let qid in data) {
                //alert(qid)
                let treatment_data = data[qid]["onkopus_aggregator"]["aggregated_evidence_data"]

                if (this.sortStates[feature] == 0) {
                    // des
                    this.isLoading = true
                    //let sorted_new = Object.keys(data).sort( (x,y) => data[x][feature] > data[y][feature] ? -1 : 1).map(f => data[f] )
                    let sorted_new = Object.keys(treatment_data).sort( (x,y) => treatment_data[x][feature] > treatment_data[y][feature] ? -1 : 1).map(f => treatment_data[f] )
                    //alert(JSON.stringify(sorted_new))
                    data[qid]["onkopus_aggregator"]["aggregated_evidence_data"] = sorted_new

                    this.$store.dispatch('setActiveBiomarker',data)

                    for (let k in this.sortStates) {
                        this.sortStates[k] = 0
                    }
                    for (let k in this.iconStatesUp) {
                        this.iconStatesUp[k] = 'mdi-arrow-up-thin'
                    }
                    for (let k in this.iconStatesDn) {
                        this.iconStatesDn[k] = 'mdi-arrow-down-thin'
                    }

                    this.sortStates[feature] = 1
                    this.iconStatesDn[feature]= 'mdi-arrow-down-bold-box'
                    this.iconStatesUp[feature]= 'mdi-arrow-up-thin'
                    this.isLoading = false
                } else {
                    // asc
                    this.isLoading = true
                    //let sorted_new = Object.keys(data).sort( (x,y) => data[x][feature] > data[y][feature] ? -1 : 1).map(f => data[f] )
                    let sorted_new = Object.keys(treatment_data).sort( (x,y) => treatment_data[x][feature] < treatment_data[y][feature] ? -1 : 1).map(f => treatment_data[f] )
                    //alert(JSON.stringify(sorted_new))
                    data[qid]["onkopus_aggregator"]["aggregated_evidence_data"] = sorted_new

                    this.$store.dispatch('setActiveBiomarker',data)

                    for (let k in this.sortStates) {
                        this.sortStates[k] = 0
                    }
                    for (let k in this.iconStatesUp) {
                        this.iconStatesUp[k] = 'mdi-arrow-up-thin'
                    }
                    for (let k in this.iconStatesDn) {
                        this.iconStatesDn[k] = 'mdi-arrow-down-thin'
                    }

                    this.sortStates[feature] = 0
                    this.iconStatesDn[feature]= 'mdi-arrow-down-thin'
                    this.iconStatesUp[feature]= 'mdi-arrow-up-bold-box'
                    this.isLoading = false
                }
            }
        }
    },
    mounted: async function() {

        this.carousel = this.carousel +1;
        this.carousel = this.carousel +1;
        this.carousel = this.carousel +1;
        this.carousel=0;

        let url = this.$store.getters.getPathVariable('methods_generate_plot')

        let formData = new FormData();
        formData.append("plot", "treatment-sunburst");
        formData.append("qid",Object.keys(this.$store.getters.getActiveBiomarker))
        //formData.append("variant_data", JSON.stringify(this.$store.getters.getVariants) )
        //formData.append("mutation_type", "genes")
        //alert(Object.keys(this.$store.getters.getActiveBiomarker))
        //alert(JSON.stringify(this.$store.getters.getVariants))
        formData.append("request_id", this.$store.getters.requestID)
        //let content = await axios.post(url, formData, {
        //  headers: {
        //    "Content-Type": "text/html"
        //  }
        //});

                 /*   var elementExists = document.getElementById("chart-sunburst-biomarker-1-thumb");
            alert("el1:"+elementExists)
            elementExists = document.getElementById("chart-sunburst-biomarker-2-thumb");
            alert("el2:"+elementExists)
                        elementExists = document.getElementById("chart-sunburst-biomarker-3-thumb");
            alert("el3:"+elementExists)
                        elementExists = document.getElementById("chart-sunburst-biomarker-4-thumb");
            alert("el4:"+elementExists)
                        elementExists = document.getElementById("chart-sunburst-biomarker-5-thumb");
            alert("el5:"+elementExists)*/

        // graph1
        await axios.post(url, formData, {
          headers: {
            "Content-Type": "text/html"
          }
        }).then((response) => {
            var response_data = response.data
                    this.$store.dispatch("setProcessState",["load-sunburst-1-thumb","<div>" + response_data + "</div>"])
                    this.TreatmentsSunburst1 = ""
                    var graphJSON = response.data
                    this.redrawBiomarkerSunburstPlot(graphJSON)

                    this.$store.dispatch('setProcessState', [  "load-sunburst-1-thumb","" ] )
        })

        // graph2
        formData = new FormData();
        formData.append("plot", "treatment-sunburst-cancer-type");
        //formData.append("variant_data", JSON.stringify(this.$store.getters.getVariants) )
        formData.append("qid", Object.keys(this.$store.getters.getActiveBiomarker))
        formData.append("request_id", this.$store.getters.requestID)
        //formData.append("mutation_type", "genes")

        await axios.post(url, formData, {
          headers: {
            "Content-Type": "text/html"
          }
        }).then((response) => {
            var response_data = response.data
                    this.$store.dispatch("setProcessState",["load-sunburst-2-thumb","<div>" + response_data + "</div>"])
                    this.TreatmentsSunburst1 = ""
                    var graphJSON = response.data
                    this.redrawBiomarkerSunburstPlot2(graphJSON)

                    this.$store.dispatch('setProcessState', [  "load-sunburst-2-thumb","" ] )
        })



        // graph3
            //var elementExists = document.getElementById("chart-sunburst-biomarker-3-thumb");
            //if ((elementExists) && (plot3_loaded==false)) {
                //alert("Element exists");

                formData = new FormData();
                formData.append("plot", "treatment-sunburst-match-type-drugs");
                //formData.append("variant_data", JSON.stringify(this.$store.getters.getVariants) )
                formData.append("qid", Object.keys(this.$store.getters.getActiveBiomarker))
                formData.append("request_id", this.$store.getters.requestID)
                //formData.append("mutation_type", "genes")

                await axios.post(url, formData, {
                  headers: {
                    "Content-Type": "text/html"
                  }
                }).then((response) => {
                    var response_data = response.data
                            this.$store.dispatch("setProcessState",["load-sunburst-3-thumb","<div>" + response_data + "</div>"])
                            this.TreatmentsSunburst1 = ""
                            var graphJSON = response.data
                            this.redrawBiomarkerSunburstPlot3(graphJSON,'chart-sunburst-biomarker-3')

                            this.$store.dispatch('setProcessState', [  "load-sunburst-3-thumb","" ] )
                            //plot3_loaded = true
                })
            //} else {
            //    alert("Element does not exist");
            //}


            // graph4
                formData = new FormData();
                formData.append("plot", "treatment-sunburst-match-type-drug-classes");
                //formData.append("variant_data", JSON.stringify(this.$store.getters.getVariants) )
                formData.append("qid", Object.keys(this.$store.getters.getActiveBiomarker))
                formData.append("request_id", this.$store.getters.requestID)
                //formData.append("mutation_type", "genes")

                await axios.post(url, formData, {
                  headers: {
                    "Content-Type": "text/html"
                  }
                }).then((response) => {
                    var response_data = response.data
                            this.$store.dispatch("setProcessState",["load-sunburst-4-thumb","<div>" + response_data + "</div>"])
                            this.TreatmentsSunburst1 = ""
                            var graphJSON = response.data
                            this.redrawBiomarkerSunburstPlot4(graphJSON)

                            this.$store.dispatch('setProcessState', [  "load-sunburst-4-thumb","" ] )
                            //plot4_loaded = true
                })




            // graph5
                formData = new FormData();
                formData.append("plot", "treatment-sunburst-response-type");
                //formData.append("variant_data", JSON.stringify(this.$store.getters.getVariants) )
                formData.append("qid", Object.keys(this.$store.getters.getActiveBiomarker))
                formData.append("request_id", this.$store.getters.requestID)
                //formData.append("mutation_type", "genes")

                await axios.post(url, formData, {
                  headers: {
                    "Content-Type": "text/html"
                  }
                }).then((response) => {
                    var response_data = response.data
                            this.$store.dispatch("setProcessState",["load-sunburst-5-thumb","<div>" + response_data + "</div>"])
                            this.TreatmentsSunburst1 = ""
                            var graphJSON = response.data
                            this.redrawBiomarkerSunburstPlot3(graphJSON,'chart-sunburst-biomarker-5')

                            this.$store.dispatch('setProcessState', [  "load-sunburst-5-thumb","" ] )
                            //plot5_loaded = true
                })


        //this.loadSunburstPlots()

    },
    setup() {
      return {
        modules: [Navigation],
      };
    },

}
</script>